import React from 'react';
import Geolocation from "react-geolocation";
import Maps from './Map'

import { Button, ButtonToolbar, Panel } from 'react-bootstrap';
import Center from 'react-center';

var divStyle = {
  padding: "20px",
  marginTop: "50px"
};

var dbtnStyle = {
  padding: "20px",
};

var outOfAreaStyle1 = {
  marginTop: "0px",
  padding: "0px",
  backgroundColor: '#c0392b',
};
var outOfAreaStyle2 = {
  marginTop: "0px",
  padding: "0px",
  paddingBottom: "3px",
  backgroundColor: '#c0392b',
};

export default class GeolocationMap extends React.Component {
  constructor (props, context) {
    super(props, context)
	this.first_call = true;
  this.state = {
    'count': 0,
   }
  }

  componentDidMount(){
    const { transit } = this.props
  }
  
  goToSetting()
  {
	  console.log('go to setting')
  }
  
  cancel()
  {
	window.close();
	console.log('exit')
  }

  gpsChecking(longitude, latitude)
  {
	  window.open('', '_parent', '')
	  
	  if(latitude == null)
	  {
		  return (
		  <Center>
		  <div style={divStyle}>
				<div>
					<Panel bsStyle="success">
						<Panel.Body >
							<div >
							<Center>
							<h2>กรุณาเปิด GPS</h2>
							</Center>
							</div>
							{/*  <div style={dbtnStyle} >
								<ButtonToolbar>
								  <Button bsSize="large" active onClick={this.goToSetting}>
									ตั้งค่า
								  </Button>
								  <Button bsSize="large" active onClick={this.cancel}>
									ยกเลิก
								  </Button>
								</ButtonToolbar>
							</div> */}
						</Panel.Body>
					</Panel>
				</div>
			</div>
			</Center>
			);
	  }
    else
    {

      
      let url = 'https://transitapi.traffy.in.th/api/prediction/get_bus_with_predict.php?longitude='+ longitude +'&latitude='+ latitude

      fetch(url).then( res => {
        return res.json()
      }).then( data => {
        this.setState({count: data.count})
      });

      if(this.state.count <= 0)
      {
        latitude = 7.891029
        longitude = 98.392204
        
        return (
            <div >
              <div style={outOfAreaStyle1}>
                <Center>
                    <font color="white"><b>คุณอยู่นอกเขตให้บริการ!<br/></b></font>
                </Center>
              </div>
              <div style={outOfAreaStyle2}>
                <Center>
                    <font color="white" size="2">หมายเหตุ : แสดงข้อมูลเสมือนอยู่ที่ อำเภอเมือง จังหวัดภูเก็ต</font>
                </Center>
              </div>
              <Maps isMarkerShown lati={latitude} long={longitude} {...this.props} />
            </div>
        );
      }
      else
      {
        return (
            <div >
              <div >
                <Maps isMarkerShown lati={latitude} long={longitude} {...this.props} />
              </div>
            </div >
        );
      }

    }
  }

  render(){
    return (
      <Geolocation
        render={({
			fetchingPosition,
			position: { coords: { latitude, longitude } = {} } = {},
			error,
			getCurrentPosition
        }) =>
			<div >
				{ this.gpsChecking(longitude, latitude) }
			</div>}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/GeoLocation.js